import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A component that renders the requested Flags icon
 */
export const Flags = ({ ChosenFlag, title, ...rest }) => {
    const titleId = title?.replace(/\s+/g, '-').toLowerCase();
    return _jsx(ChosenFlag, { title: title, titleId: titleId, ...rest });
};
//# sourceMappingURL=flags.js.map